<template>
  <table class="table table-bordered">
    <tbody>

      <tr>
        <th scope="row">Name:</th>
        <td>{{ client.name }}</td>
      </tr>

      <tr>
        <th scope="row">Client ID:</th>
        <td>{{ client.clientId }}</td>
      </tr>

      <tr>
        <th scope="row">Email:</th>
        <td>{{ client.email }}</td>
      </tr>

      <tr>
        <th scope="row">Phone:</th>
        <td>{{ client.phone }}</td>
      </tr>

      <tr>
        <th scope="row">Contract Id:</th>
        <td>{{ client.contractId }}</td>
      </tr>

      <tr>
        <th scope="row">Portfolio Id:</th>
        <td>{{ client.portfolios[0] }}</td>
      </tr>

      <tr>
        <th scope="row">Groups:</th>
        <td>
          <ul>
            <li v-for="group in groups">
              <div class="form-check">
                <!-- <input class="form-check-input" type="checkbox" checked :id="group.id"> -->
                <input class="form-check-input" type="radio" name="groupscheckbox" :value="group.id" v-model="cgroups" :id="group.id" @click="toggleCheck" @change="toggleGroup">
                <label class="form-check-label" :for="group.id">{{ group.name }}</label>
              </div>
            </li>
          </ul>
        </td>
      </tr>

    </tbody>
  </table>
</template>


<script>
export default {
  props: ['client', 'groups'],
  data() {
    return {
      cgroups: this.client.cgroups[0],
      ans: false,
    }
  },
  watch: {
    client() {
      this.cgroups = this.client.cgroups[0]
    },
  },
  methods: {
    toggleCheck: function(event) {
      if (confirm('Are you sure?')) {
        event.target.checked = true
      } else {
        event.preventDefault()
      }
    },
    toggleGroup() {
      // event.preventDefault()
      // this.ans = confirm('Are you sure?')
      // event.target.checked = this.ans
      // if (this.ans) {
      this.$store.dispatch('updateClientGroups', {
        id: this.client.id,
        cgroups: this.cgroups,
      })
      // }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/tables/ClientTable.vue